/**
 * Выписка `1CClientBankExchange`: интернет-банки чаще отдают её в Windows-1251, реже в UTF-8.
 * Сначала строгая проверка UTF-8: кириллица в Windows-1251 такую проверку не проходит.
 */
export function decodeStatement(bytes: ArrayBuffer): string {
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
  } catch {
    return new TextDecoder('windows-1251').decode(bytes);
  }
}
